// Kept in sync with the packages registered in public/.well-known/assetlinks.json.
const TWA_PACKAGES = [
  'com.sorare.app.android',
  'com.sorare.app.android.dev',
  'com.sorare.app.android.debug',
];

const ANDROID_APP_REFERRER = /^android-app:\/\/([^/?#]+)/;

// The package of the Android shell that launched this page, when it is one of ours.
export const twaPackageFromReferrer = (referrer: string) => {
  const packageName = ANDROID_APP_REFERRER.exec(referrer)?.[1];
  return packageName !== undefined && TWA_PACKAGES.includes(packageName)
    ? packageName
    : undefined;
};

export const isTrustedTwaReferrer = (referrer: string) =>
  twaPackageFromReferrer(referrer) !== undefined;
